import {Component, Input, OnInit} from '@angular/core';
import {FonteDadosService} from '../fonte-dados.service';
import {FonteDados} from '../fonte-dados.model';
import {AplicacaoK8s} from '../aplicacao-k8s.model';
import {PodK8s} from '../pod-k8s.model';
import {ParametroService} from '../../parametro/parametro.service';
import { MensagemService } from 'maestro-ng';
import {ParametroNomeMicroServicoVersao} from '../../models/fonte-dados-versao-detalhes';
import {Parametro} from '../../parametro/parametro.model';
import {Monitoramento} from '../monitoramento.model';
import {AplicacaoMonitoramentoDetalhado} from '../../monitoramento/aplicacao-monitoramento-detalhado.model';
import {firstValueFrom} from 'rxjs';

@Component({
  selector: 'app-fonte-dados-infraestrutura',
  templateUrl: './fonte-dados-infraestrutura.component.html',
  styleUrls: ['./fonte-dados-infraestrutura.component.css']
})
export class FonteDadosInfraestruturaComponent implements OnInit {
  logPod: string;
  private blob: Blob;
  private podReiniciar: PodK8s;



  constructor(private fonteDadosService: FonteDadosService,
              private parametroService: ParametroService,
              private mensagemService: MensagemService) {
  }

  @Input()
  public fonteDados: FonteDados;

  @Input()
  public monitoramento: Monitoramento;

  @Input()
  tabSelecionada = false;

  aplicacoes: AplicacaoK8s[];
  podSelecionado: PodK8s;
  mostrarLogs = false;
  modalAtualizarVersaoVisivel = false;
  aplicacaoSelecionada: AplicacaoK8s;
  containerSelecionado: string;
  parametroVersao: Parametro;
  versaoAtual: string;
  atualizacaoAutomatica = true;
  versaoAtualizacao: string;
  modalReiniciarPod: boolean;

  tentativasPosErro = 0;
  maxTentativasPosErro = 5;
  msgErro: string;

  ngOnInit(): void {
    this.carregarAplicacoes();
    setInterval(
      () => this.atualizarAplicacoesAutomaticamente(),
      5000
    );
    this.atualizarLogAutomaticamente();
  }

  private atualizarAplicacoesAutomaticamente() {
    if (this.atualizacaoAutomatica && this.tabSelecionada) {
      this.carregarAplicacoes();
    }
  }

  private carregarAplicacoes() {
    this.fonteDadosService.recuperarAplicacoes(this.fonteDados).subscribe(
      (res) => this.aplicacoes = res,
      (e) => {
        this.mensagemService.addErro('Erro ao carregar aplicacoes', e.error);
        this.msgErro = e.error;
        this.tentativasPosErro++;
        if (this.tentativasPosErro >= this.maxTentativasPosErro) {
          this.atualizacaoAutomatica = false;
        }
      }
    );
  }

  getClasseStatus(status: string): string {
    if (status) {
      if (status.includes('_')) {
        return status.substr(0, status.indexOf('_')).toLowerCase();
      }
      return status.toLowerCase();
    }
  }

  getClasseIcon(status: string): string {
    let icon;
    switch (status) {
      case 'EXECUTANDO':
        icon = 'pi-spinner';
        break;
      case 'PENDENTE'            :
        icon = 'pi-pause';
        break;
      case 'PENDENTE_INICIANDO'  :
        icon = 'pi pi-ellipsis-h';
        break;
      case 'PENDENTE_COM_ERRO'   :
        icon = 'pi pi-pause';
        break;
      case 'CONCLUIDO'           :
      case 'CONCLUIDO_COM_SUCESSO':
        icon = 'pi pi-check-circle';
        break;
      case 'CONCLUIDO_COM_ERRO'  :
        icon = 'pi pi-times-circle';
        break;
    }
    return icon;
  }

  carregarLog(aplicacao: string, pod: PodK8s) {
    this.mostrarLogs = false;
    this.podSelecionado = pod;
    this.podSelecionado.aplicacao = aplicacao;
    firstValueFrom(this.fonteDadosService.recuperarPodLogs(this.fonteDados, this.podSelecionado, this.containerSelecionado, 100))
      .then((res) => this.logPod = res);
    this.mostrarLogs = true;
  }

  downloadLogPodSelecionado() {
    this.fonteDadosService.recuperarPodLogs(this.fonteDados, this.podSelecionado, this.containerSelecionado)
      .subscribe(
        (data) => {
          this.blob = new Blob([data], {type: 'txt/plain'});
        },
        (e) => this.mensagemService.addErro('Erro ao realizar o download', e),
        () => {
          const downloadURL = window.URL.createObjectURL(this.blob);
          const link = document.createElement('a');
          link.href = downloadURL;
          link.target = '_blank';
          link.download = this.podSelecionado.nome + '.log';
          link.click();
        });
  }

  reiniciarPodSelecionado() {
    this.reiniciarPod(this.podSelecionado);
  }

  reiniciarPod(pod?: PodK8s, aplicacao?: AplicacaoK8s) {
    if (!pod && this.modalReiniciarPod) {
      pod = this.podReiniciar;
    }
    if (aplicacao) {
      pod.aplicacao = aplicacao.aplicacao;

    }
    this.modalReiniciarPod = false;
    this.fonteDadosService.reiniciarPod(this.fonteDados, pod)
      .subscribe(
        () => {
          this.podSelecionado = null;
          this.logPod = null;
        },
        (e) => this.mensagemService.addErro('Erro ao reiniciar pod', e),
        () => this.carregarAplicacoes()
      );
  }

  reiniciarAplicacao(aplicacao: AplicacaoK8s) {
    if (aplicacao && aplicacao.pods) {
      aplicacao.pods.forEach(pod => {
        pod.aplicacao = aplicacao.aplicacao;
        this.reiniciarPod(pod);
      });
    }
  }

  private atualizarLogAutomaticamente() {
    setInterval(
      () => {
        if (this.podSelecionado && this.tabSelecionada) {
          this.carregarLog(this.podSelecionado.aplicacao, this.podSelecionado);
        }
      },
      5000
    );
  }

  onChangeContainer(event) {
    if (event.value) {
      this.containerSelecionado = event.value;
      this.carregarLog(this.podSelecionado.aplicacao, this.podSelecionado);
    }
  }

  private recuperarDadosVersao(aplicacao: AplicacaoK8s) {
    let idParametro: string;
    let monitoramentoDetalhado: AplicacaoMonitoramentoDetalhado<any>;
    switch (aplicacao.aplicacao) {
      case 'EXTRATOR':
        idParametro = ParametroNomeMicroServicoVersao.ULTIMA_VERSAO_EXTRATOR;
        monitoramentoDetalhado = this.monitoramento.extrator;
        break;
      case 'IRIS':
        idParametro = ParametroNomeMicroServicoVersao.ULTIMA_VERSAO_IRIS;
        monitoramentoDetalhado = this.monitoramento.iris;
        break;
      case 'CONVERSOR':
        idParametro = ParametroNomeMicroServicoVersao.ULTIMA_VERSAO_CONVERSOR;
        monitoramentoDetalhado = this.monitoramento.conversor;
        break;
      case 'PRISMA':
        idParametro = ParametroNomeMicroServicoVersao.ULTIMA_VERSAO_PRISMA;
        monitoramentoDetalhado = this.monitoramento.prisma;
        break;
    }

    this.versaoAtual = monitoramentoDetalhado.monitoramento.aplicacao.versao.toString();
    this.parametroService.recuperarPorId(idParametro)
      .then(item => {
        this.parametroVersao = item;
      })
      .catch(erro =>
        this.mensagemService.addErro('Erro', `Erro ao encontrar parâmetro Conversor: ${erro}`)
      ).finally(
        () => this.versaoAtualizacao = this.parametroVersao?.valor
      );

  }

  modalAtualizarVersao(aplicacao: AplicacaoK8s): void {
    this.modalAtualizarVersaoVisivel = true;
    this.fonteDadosService.recuperarAplicacao(this.fonteDados, aplicacao.aplicacao)
      .subscribe(
        (dados) => this.aplicacaoSelecionada = dados,
        (e) => this.mensagemService.addErro('Erro ao pesquisar aplicação', e),
        () => this.recuperarDadosVersao(this.aplicacaoSelecionada)
      );
  }

  atualizarVersao(): void {
    this.fonteDadosService.atualizarVersao(this.fonteDados, this.aplicacaoSelecionada, this.versaoAtualizacao).subscribe(
      () => {
        this.modalAtualizarVersaoVisivel = false;
        this.carregarAplicacoes();
      },
      (e) => this.mensagemService.addErro('Ocorreu um erro ao atualizar a versão', e?.error)
    );
  }

  temMultiplasImagens(aplicacao: AplicacaoK8s): boolean {
    if (aplicacao.pods.length === 1) {
      return false;
    }
    const imagens = new Set<string>();
    aplicacao.pods.forEach(pod => {
      pod.containers.forEach(c => imagens.add(c.imagem));
    });

    return imagens.size > 1;
  }


  dialogReiniciarPod(pod: PodK8s, aplicacao: AplicacaoK8s ) {
    this.podReiniciar = pod;
    this.podReiniciar.aplicacao = aplicacao.aplicacao;
    this.modalReiniciarPod = true;
  }
}
